import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";
import ContactTemplate from "../util/ContactTemplate";
import { useSnackbar } from 'react-simple-snackbar';
import { danger } from '../util/AlertStyles';

const fields = {
    companyName: "bedrijfsnaam",
    name: "naam",
    streetno: "straatnaam en/of huisnummer",
    areaCode: "postcode / area code",
    town: "stad",
    country: "land",
    telephone: "telefoonnummer",
    telephoneCode: "telefoon landcode",
    email: "emailadres",
    VATNO: "BTW nummer (VAT No.)",
    customsNO: "Douane nummer (Customs No. / EORI No.)"
}

const checkEntries = (input) => {
    const entries = Object.entries(input);
    for (const kv of entries) {
        if (!(kv[1] || kv[1] === 0)) {
            return fields[kv[0]];
        }
    }
    return false;
};

const ContactInformation = () => {
    const [sender, setSender] = useState();
    const [recipient, setRecipient] = useState();
    const [rememberAddress, setRememberAddress] = useState(
        window.localStorage.getItem("contactAddress") !== null
    );

    const { addBreadcrumb } = useBreadcrumbs();
    const [addAlert] = useSnackbar(danger);

    const nextPage = () => {
        let missing = checkEntries(sender);
        if (missing) {
            addAlert(`Vul alstublieft alle velden in, ${missing} van de verzender ontbreekt`);
            return;
        }
        missing = checkEntries(recipient);
        if (missing) {
            addAlert(`Vul alstublieft alle velden in, ${missing} van de ontvanger ontbreekt`);
            return;
        }
        addBreadcrumb(
            {
                href: "/contents",
                text: "Inhoud"
            },
            {
                sender,
                recipient
            }
        );
    };

    useEffect(() => {
        if (rememberAddress) {
            window.localStorage.setItem(
                "contactAddress",
                JSON.stringify(sender)
            );
        } else {
            window.localStorage.removeItem("contactAddress");
        }
    }, [rememberAddress, sender]);

    useEffect(() => {
        if (recipient) window.sessionStorage.setItem("recipientAddress", JSON.stringify(recipient));
    }, [recipient])

    return (
        <AnimateWrapper>
            <BasicQuestion
                question={"Contactgegevens verzender"}
                answers={
                    <>
                        <Col xs={12}>
                            <ContactTemplate
                                setContact={setSender}
                                rememberAddress={rememberAddress}
                                setRememberAddress={setRememberAddress}
                            />
                        </Col>
                    </>
                }
            />
            <BasicQuestion
                question={"Contactgegevens ontvanger"}
                answers={
                    <>
                        <Col xs={12}>
                            <ContactTemplate
                                sender={false}
                                setContact={setRecipient}
                            />
                        </Col>
                        <Col xs={12}>
                            <ChoiceCard
                                body="Doorgaan"
                                onClick={nextPage}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default ContactInformation;
